// extracted by mini-css-extract-plugin
export default {"menu":"MenuLink-module--menu--930e9","app":"MenuLink-module--app--b9f4d"};